import React, { useEffect, useState } from "react";
import axios from "axios";
import "../styles/Items.css";


interface Item {
  "Category Description": string;
  "Product Description and Size": string;
  UPC: string;
  imageUrl: string;
}

const Items: React.FC = () => {
  const [items, setItems] = useState<Item[]>([]);

  useEffect(() => {
    axios
      .get(
        "https://data.chhs.ca.gov/api/3/action/datastore_search?resource_id=e69c04d2-afba-41be-bcac-ca2ebffb2c91&limit=5"
      )
      .then((res) => {
        const images = res.data.result.records.map((item: Item, index) => ({
          ...item,
          imageUrl: getImageUrl(index),
        }));
        setItems(images);
      })
      .catch((error) => {
        console.error("Error", error);
      });
  }, []);

  const getImageUrl = (index: number): string => {
    const imagePaths = [
      "krogerColbyMontereyJack.png",
      "krogerMontereyJack.png",
      "krogerMozarella.png",
      "mooveleusColbyJack.png",
      "moovelusMildCheddar.png",
    ];
    return "/assets/" + imagePaths[index];
  };

  return (
    <div className="dashboard-items-container">
      {items.map((item, index) => (
        <div key={index} className="dashboard-item">
          <img
            src={item.imageUrl}
            alt={`${item["Category Description"]}`}
          />
          <div className="item-details">
          <div><strong>Category:</strong> {item["Category Description"]}</div>
          <div>
          <strong>Product:</strong> {item["Product Description and Size"]}
          </div>
          <div><strong>UPC:</strong> {item["UPC"]}</div>
        </div>
        </div>
      ))}
    </div>
  );
};

export default Items;
